// src/pages/nationalities/EditNationalities.jsx

import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import FormAddEditNationalities from "../../components/nationalities/FormAddEditNationalities";
import useGetNationality from "../../hooks/nationalities/useGetNationality";
import { CircularProgress, Box } from "@mui/material";

const EditNationalities = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { isLoading, nationality } = useGetNationality(id);

    if (isLoading) {
        return (
            <WrapperSection>
                <Box display="flex" justifyContent="center" p={4}>
                    <CircularProgress />
                </Box>
            </WrapperSection>
        );
    }

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditNationalities
                isEdit={true}
                currentData={nationality}
                onSubmitSuccess={() => navigate("/nationalities")}
            />
        </WrapperSection>
    );
};

export default EditNationalities;